import {
  AccordionSummary,
  Stack,
  Typography,
  Box,
  Accordion as MUIAccordion,
  AccordionDetails,
} from '@mui/material'
import type { AccordionHeaderProps } from './types'
import type { PropsWithChildren } from 'react'
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded'
import { styles } from './styles'

export const Accordion = (props: PropsWithChildren<AccordionHeaderProps>) => {
  const {
    title,
    titleStyle,
    status,
    children,
    buttons,
    color = 'default',
    ...rest
  } = props

  return (
    <MUIAccordion sx={{ ...styles.root, ...styles.root[color] }} {...rest}>
      <Stack
        sx={{ ...styles.root.header }}
        direction={'row'}
        alignItems={'center'}
        justifyContent={'space-between'}
      >
        {/* <AccordionSummary> */}
        <Stack
          justifyContent={'space-between'}
          direction={'row'}
          alignItems={'center'}
          sx={{ width: '100%' }}
        >
          <Stack gap={1.5} alignItems={'center'} direction={'row'}>
            <Typography style={titleStyle}>{title}</Typography>
            {status}
          </Stack>
          <Box></Box>
        </Stack>
        {/* </AccordionSummary> */}
        <Box mr={2.5}>{buttons}</Box>
        <AccordionSummary>
          <Box sx={styles.root.iconArrow}>
            <ArrowForwardIosRoundedIcon className={'Accordion-arrow'} />
          </Box>
        </AccordionSummary>
      </Stack>
      <AccordionDetails>{children}</AccordionDetails>
    </MUIAccordion>
  )
}
